import React from 'react';
import './Styles/LazyImage.css';

export class LazyImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      intersecting: false
    };
    this.imgRef = React.createRef();
  }

  handleIntersection = entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.setState({ intersecting: true });
      }
    });
  };

  componentDidMount() {
    this.observer = new IntersectionObserver(this.handleIntersection);
    this.observer.observe(this.imgRef.current);
  }

  componentWillUnmount() {
    this.observer.unobserve(this.imgRef.current);
    this.observer = null;
  }

  render() {
    const { size, alt, image } = this.props;
    const contStyles = {
      backgroundSize: `${size.width * 3}px ${size.height}px`,
      maxWidth: `${size.width}px`,
      height: `${size.height}px`
    };

    return (
      <div
        className="LazyImage__Container"
        style={contStyles}
        ref={this.imgRef}
      >
        <img
          className="LazyImage__Image"
          src={this.state.intersecting ? image : ''}
          alt={alt}
          style={this.state.intersecting ? {} : { display: 'none' }}
        />
      </div>
    );
  }
}
